"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredPaymentDataDirectDebitToJSON = exports.StoredPaymentDataDirectDebitFromJSONTyped = exports.StoredPaymentDataDirectDebitFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function StoredPaymentDataDirectDebitFromJSON(json) {
    return StoredPaymentDataDirectDebitFromJSONTyped(json, false);
}
exports.StoredPaymentDataDirectDebitFromJSON = StoredPaymentDataDirectDebitFromJSON;
function StoredPaymentDataDirectDebitFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'allowed': json['allowed'],
        'current': !(0, runtime_1.exists)(json, 'current') ? undefined : (0, _1.StoredPaymentDataDirectDebitCurrentFromJSON)(json['current']),
    };
}
exports.StoredPaymentDataDirectDebitFromJSONTyped = StoredPaymentDataDirectDebitFromJSONTyped;
function StoredPaymentDataDirectDebitToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'allowed': value.allowed,
        'current': (0, _1.StoredPaymentDataDirectDebitCurrentToJSON)(value.current),
    };
}
exports.StoredPaymentDataDirectDebitToJSON = StoredPaymentDataDirectDebitToJSON;
//# sourceMappingURL=StoredPaymentDataDirectDebit.js.map